:host {
  font-family: var(--ux-font);
  font-size: var(--ux-tag-font-size);
  font-weight: var(--ux-tag-font-weight);
  align-items: center;
  background-color: var(--ux-tag-background-color);
  border-radius: var(--ux-tag-border-radius);
  border: var(--ux-tag-border);
  color: var(--ux-tag-color);
  display: inline-flex;
  justify-content: space-between;
  letter-spacing: var(--ux-tag-letter-spacing);
  line-height: 1;
  margin-inline: calc(var(--ux-tag-margin) / 2) calc(var(--ux-tag-margin) / 2);
  min-height: var(--ux-tag-height);
  padding: var(--ux-tag-padding);
  text-decoration: none;
  text-rendering: optimizeLegibility;
  text-transform: var(--ux-tag-text-transform);
  transition: var(--ux-tag-transition);
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  outline-offset: -1px;
  outline: 1px solid transparent;

  ux-icon {
    fill: var(--ux-tag-icon-color);
    margin-inline: var(--ux-tag-icon-margin-start);
    font-size: var(--ux-tag-icon-size);
  }
}

:host([removable]) {
  cursor: pointer;
  border: var(--ux-tag-border-removable);
  color: var(--ux-tag-color-removable);
  transition: var(--ux-tag-transition);
}

:host(:focus),
:host(:active) {
  outline: var(--ux-tag-outline-focus);
  outline-offset: -2px;
}

:host(:hover) {
  background-color: var(--ux-tag-background-color-hover);
  color: var(--ux-tag-hover-color);
  outline: var(--ux-tag-outline-hover);

  ux-icon {
    fill: var(--ux-tag-icon-color-hover);
  }
}

:host-context([dir="rtl"]) {
  .ux-tag__label {
    direction: rtl;
    unicode-bidi: bidi-override;
  }
}
